<template>
  <div class="wrap" @click="outFiltrate">
    <header>
      <h3 v-if="row.transModel!=1">
        单选指定给1名{{ til }}，多选将均分并指定给多人在线协作（最多10名{{
            til
          }}）
      </h3>
      <h3 v-else>
        最多分配给50名同学作业，文件不拆分，不锁定重复内容
      </h3>
      <input type="text" v-model="search_mod" placeholder="请输入姓名" @keyup.enter="seek" />
      <el-popover v-if="!$independence && row.transModel!=1" placement="bottom" width="200" trigger="manual" v-model="visible"
        style="padding-bottom: 0px;">
        <el-form class="filterForm" label-position="right" label-width="70px" :model="formLabelAlign">
          <el-form-item label="擅长语言">
            <el-select v-model="formLabelAlign.lang_desc" placeholder="请选择擅长语言" @change="changeFiltrate">
              <el-option label="全部" value></el-option>
              <el-option v-for="(item, index) in langDescList" :key="index" :label="item.tagName" :value="item.tagCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="擅长领域">
            <el-select v-model="formLabelAlign.domain_code" placeholder="请选择擅长领域" @change="changeFiltrate">
              <el-option label="全部" value></el-option>
              <el-option v-for="(item, index) in domainList" :key="index" :label="item.tagName" :value="item.tagCode">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-button class="sortFiltrate" slot="reference" @click.stop="onFiltrate">
          筛选
          <i class="el-icon--right" :class="iconCaret"></i>
        </el-button>
      </el-popover>
      <i class="search el-icon-search" @click="seek"></i>
    </header>
    <template>
      <!-- <div style="overflow: auto;height:100%"> -->
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width:100%"
        @selection-change="handleSelectionChange" v-loading="loading">
        <template slot="empty">
          <div id="notDate">
            <img src="../../assets/imgs/memory/no_data.png" alt />
            <p>暂无数据，快去创建吧</p>
          </div>
        </template>
        <el-table-column type="selection" :selectable="selectable" width="60"></el-table-column>
        <el-table-column prop="aliasName" :show-overflow-tooltip="true" label="姓名" width></el-table-column>
        <el-table-column v-if="!$independence && row.transModel!=1" prop="langTagList" :show-overflow-tooltip="true" label="擅长语言"
          width="">
          <template slot-scope="scope">
            <span v-show="scope.row.langTagList.length > 0" v-for="(item, index) in scope.row.langTagList"
              :key="index">{{ item.tagName }}&nbsp;</span>
            <span v-show="scope.row.langTagList.length < 1">--</span>
          </template>
        </el-table-column>
        <el-table-column v-if="!$independence && row.transModel!=1" prop="domainTagList" :show-overflow-tooltip="true" label="擅长领域">
          <template slot-scope="scope">
            <span v-show="scope.row.domainTagList.length > 0" v-for="(item, index) in scope.row.domainTagList"
              :key="index">{{ item.tagName }}&nbsp;</span>
            <span v-show="scope.row.domainTagList.length < 1">--</span>
          </template>
        </el-table-column>
        <el-table-column prop="size" :show-overflow-tooltip="true" label="字数" width></el-table-column>
        <el-table-column prop="limitTime" label="截止时间" min-width="150">
          <template slot-scope="props">
            <div class="data_now">
              <el-date-picker type="date" align="right" :editable="false" v-model="props.row.limitTime"
                value-format="yyyy-MM-dd" placeholder="请选择日期" :clearable="false" @change="dateChange(props.row)"
                :picker-options="pickerOptions">
              </el-date-picker>
              <el-time-select v-model="props.row.timePicker" :editable="false" :clearable="false"
                @blur="timeChange(props.row,props.$index)" :picker-options="{
                    start: start(props.row.limitTime),
                    step: '00:30',
                    end: '23:30'
                  }" placeholder="选择时间">
              </el-time-select>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="proportion" :show-overflow-tooltip="true" label="分配比例" min-width="140">
          <template slot-scope="props">
            <input type="number" v-model="props.row.proportion" max="100" min="1" step="1"
              @change="proportionChange(props.row,props.$index)" />%
          </template>
        </el-table-column> -->
        <el-table-column v-if="row.transModel!=1" prop="salary" label="单价/元" min-width="140">
          <template slot-scope="props">
            <input type="number" v-model="props.row.salary" max="10000" min="10" step="10"
              @change="salaryChange(props.row)" />元/千字
            <!-- <el-input-number v-model="props.row.salary"  size="mini" controls-position="right" @change="salaryChange(props.row)" :min="1" :max="400"></el-input-number>元/千字 -->
          </template>
        </el-table-column>
      </el-table>
      <!-- </div> -->
    </template>
    <div class="btn">
      <button class="themeCallBut" @click="backtrack">取消</button>
      <button class="themeGoBut" @click="onSubmit" :disabled="disabled">确定</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "interpreter",
  props: {

  },
  data() {
    return {
      tableData: [],
      multipleSelection: [], // 存储选中的数组
      search_mod: "",
      loading: true,
      formLabelAlign: {
        lang_desc: "",
        domain_code: ""
      },
      iconCaret: "el-icon-caret-bottom",
      domainList: [],
      langDescList: [],
      visible: false,
      til: "译员",
      pickerOptions: {
        // 日期限制
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      disabled: false,
      oldUserIdList: []
    };

  },
  async created() {
    this.rowNode = this.$route.query.rowNode
    this.rowNode2 = this.$route.query.rowNode2
    this.page = this.$route.query.page
    this.queryData = JSON.parse(this.$Base64.decode(this.$route.query.key));
    this.row = this.queryData.row;
    await this.getSelfUserList();
    if (this.row.transModel == 1) {  // 0 生产模式 1 作业模式
      this.til = "学生";
      await this.getTaskUserList()
    } else {
      this.getDomainList();
      this.getLangDescList();
    }

  },

  methods: {
    selectable(row) {
      let ret = true;
      this.oldUserIdList.forEach(item => {
        if (item == row.userId) {
          ret = false;
        }
      })
      return ret
    },
    async getTaskUserList() {
      const { result, success } = await this.catReq1Service("/api/v1/fileTask/task_user_list", {
        id: this.queryData.fileId,
      });
      if (success && result.idList) {
        this.oldUserIdList = result.idList;
        this.oldUserIdList.filter(val => {
          this.tableData.forEach((item, index) => {
            if (val === item.userId) {
              this.$nextTick(() => {
                this.$refs.multipleTable.toggleRowSelection(item, true); // 将已指定学生选中 
              })
            }
          })

        })
      }
    },
    start(deliveryTime) {
      let time = "00:00"
      if (deliveryTime == "") {
        return
      }
      if (new Date(deliveryTime.replace(/-/g, '/')).getTime() < Date.now()) {
        let minu = new Date().getMinutes();
        let hour = new Date().getHours();
        if (minu >= 30) {
          minu = "00"
          hour = ++hour
        } else {
          minu = "30"
        }
        time = hour + ":" + minu
      }
      return time;
    },
    changeFiltrate() {
      this.getSelfUserList(this.search_mod);
    },
    // 关闭筛选
    outFiltrate() {
      if (this.visible) {
        this.visible = false;
        this.iconCaret = "el-icon-caret-bottom";
        // this.currentPage = 1;
        // sessionStorage.setItem("myCurrentPage", 1);
        this.getSelfUserList(this.search_mod);
      }
    },
    // 筛选
    onFiltrate() {
      this.visible = !this.visible;
      if (!this.visible) {
        this.iconCaret = "el-icon-caret-bottom";
        // this.currentPage = 1;
        // sessionStorage.setItem("myCurrentPage", 1);
        this.getSelfUserList(this.search_mod);
      } else {
        this.formLabelAlign = {
          lang_desc: "",
          domain_code: ""
        };
        this.iconCaret = "el-icon-caret-top";
      }
    },
    // 获取领域下拉选列表标签
    getDomainList() {
      var that = this;
      this.catReq1Service("/api/v1/companyUser/queryCompanyTag", {
        type: 2,
        active: 1
      }).then(function (response) {
        if (!response.success) {
          return;
        }
        that.domainList = response.result;
      });
    },
    // 获取语言对下拉选列表标签
    getLangDescList() {
      var that = this;

      this.catReq1Service("/api/v1/companyUser/queryCompanyTag", {
        type: 1,
        active: 1
      }).then(function (response) {
        if (!response.success) {
          return;
        }
        that.langDescList = response.result;
      });
    },
    // 取消
    backtrack() {
      this.$router.push({
        name: "fileList",
        params: { row: this.rowNode, page: this.page }
      });
    },
    // 指定译员
    onSelect() {
      let that = this;
      this.multipleSelection.forEach(item => {
        item.limitTime = item.limitTime + ":00";
      });
      this.oldUserIdList.filter(val => {
        for (let index = this.multipleSelection.length - 1; index >= 0; index--) {
          if (val === this.multipleSelection[index].userId) {
            this.multipleSelection.splice(index, 1)
          }
        }
      })
      if (this.multipleSelection.length < 1) {
        return
      }
      that.disabled = true;
      var params = {
        transFileTaskDtoList: this.multipleSelection,
        fileId: this.queryData.fileId,
        taskType: 1,//this.queryData.type 任务类型，1.翻译任务，2.审校任务
        appointType: this.row.transModel == 1 ? 3 : that.appointType,//分配类型，1.平均分配，2.按比例分配；默认为1 3.校园分配
      };
      this.catReq1Service("/api/v1/fileTask/appoint", params).then(function (
        response
      ) {
        that.disabled = false;
        if (response.resultCode === "1") {
          that.$router.push({
            name: "fileList",
            params: { row: that.rowNode, page: that.page, row2: that.rowNode2 }
          });
        }
      });
    },
    // 重新指定译员
    onNewSelect() {
      let that = this;
      
      // if (this.multipleSelection.length > 1) {
      //   that.$message.closeAll();
      //   this.$message({
      //     message: "最多选择一位" + this.til,
      //     type: "warning"
      //   });
      //   return;
      // }
      this.disabled = true;
      this.multipleSelection.forEach(item => {
        item.limitTime = item.limitTime + ":00";
        item.fileId = this.queryData.fileId
      });
      // let params = this.multipleSelection[0];
      // params.fileId = this.queryData.fileId;
      // params.originUserId = this.queryData.taskUserId;
      // params.taskType = 1;
      // delete params["langDesc"];
      let params = {
        originUserId: this.queryData.taskUserId,
        transFileTaskDtoList: this.multipleSelection,
        fileId: this.queryData.fileId,
        taskType: 1,//this.queryData.type 任务类型，1.翻译任务，2.审校任务
        appointType: this.row.transModel == 1 ? 3 : that.appointType,//分配类型，1.平均分配，2.按比例分配；默认为1 3.校园分配
      };
      console.log("params", params)
      this.catReq1Service("/api/v1/fileTask/changeTranslator", params).then(
        function (response) {
          that.disabled = false;
          if (!response.success) {
            return;
          }
          if (response.resultCode === "1") {
            that.$router.push({
              name: "fileList",
              params: {
                row: that.rowNode,
                page: that.page,
                row2: that.rowNode2
              }
            });
          }
        }
      );
    },
    // 数组求和
    sumArr(arr) {
      return arr.reduce(function (prev, cur) {
        return prev + cur;
      }, 0);
    },
    //数组去重
    dedupe(array) {
      return Array.from(new Set(array));
    },
    // 确定
    onSubmit() {

      var that = this;
      if (!this.multipleSelection.length) {
        this.$message({
          message: "请选择" + this.til,
          type: "warning"
        });
        return;
      }

      let numArr = []
      this.multipleSelection.forEach(item => {
        numArr.push(item.proportion)
      })
      let num = this.sumArr(numArr)

      if (num !== 100 && this.row.transModel != 1) {
        this.$message({
          message: "比例分配异常！",
          type: "warning"
        });
        return;
      }
      let removalarr = this.dedupe(numArr)
      if (removalarr.length == 2 && (removalarr[1] - removalarr[0] <= 4)) {
        this.appointType = 1
      } else {
        this.appointType = 2
      }
      let condition2 = true;
      if (!condition2 && this.row.transModel != 1) {
        this.$message({
          message: "单价不可为空为",
          type: "warning"
        });
        return;
      }
      if (this.row.projectProcessType === 1) {
        (this.queryData.taskUserId && this.row.transModel != 1) ? this.onNewSelect() : this.onSelect()
      } else {//this.queryData.level 从哪个级别跳进来的  0 文件   1  任务
        this.queryData.level == 0 ? this.onSelect() : this.onNewSelect()
      }

    },
    // 搜索
    seek() {
      // this.$emit("search",this.search_mod);
      this.search_mod = this.search_mod.replace(
        /^(\s|\u00A0)+|(\s|\u00A0)+$/g,
        ""
      );
      this.getSelfUserList(this.search_mod);
    },
    //  获取指定译员列表
    async getSelfUserList(data) {
      // 问题
      var that = this;
      var params = {
        aliasName: data,
        isContainSelf: 1,
        langCode: that.formLabelAlign.lang_desc,
        domainCode: that.formLabelAlign.domain_code,
        oldUserId: this.queryData.taskUserId
      };
      for (let propName in params) {
        if (params[propName] === "") {
          delete params[propName];
        }
      }
      for (let propName in params) {
        if (params[propName] === "" || params[propName] === null) {
          delete params[propName];
        }
      }
      await this.catReq1Service("/api/v1/companyUser/querySelfUserList", params).then(
        function (response) {
          if (!response.success) {
            return;
          }
          let type, yesterday
          if (that.row.projectProcessType == 1) {
            type = 1
          } else if (that.row.projectProcessType == 2) {
            type = 2
          } else {
            type = 3
          }

          let today = new Date(that.queryData.deliveryTime.replace(/-/g, '/'));
          if (that.queryData.level === 1) {
            yesterday = today.getTime();
          } else {
            yesterday = today.getTime() - 1000 * 60 * 60 * 24 * type;
          }
          if (yesterday - Date.parse(new Date()) < 0) {
            yesterday = new Date()
          }
          that.tableData = response.result;
          that.tableData.forEach(item => {
            item.salary = 50;
            item.limitTime = that.dateFormat(new Date(yesterday));
            item.timePicker = '12:00'
            item.domainTagList = item.domainTagList || [];
            item.langTagList = item.langTagList || [];

          });
          that.loading = false;

        }
      );
    },
    //字符串拼接
    strSplicing(str) {
      let arr = str.split("-")
      return arr.join("") * 1

    },
    handleSelectionChange(val) {
      // 选中的元素
      let num, maxNum = 10;
      let size = Math.floor(this.queryData.wordNum / val.length);
      if (this.row.transModel == 1) {
        maxNum = 50;
        size = this.queryData.wordNum;
      }
      (this.queryData.taskUserId && this.row.transModel != 1) ? (num = 1) : (num = maxNum);
      // if (val.length > num) {
      //   num === 1 ? "一" : num;
      //   this.$message.closeAll();
      //   this.$message({
      //     message: `最多选择${num}位${this.til}`,
      //     type: "warning"
      //   });

      // }
      let proportion = Math.floor(100 / val.length)
      var arr = [];
      this.tableData.forEach(item => {
        item.size = null;
      });
      this.tableData.forEach(item => {
        item.proportion = null;
      });
      val.forEach(item => {
        item.size = size; // 字数
        item.proportion = proportion // 比例
        arr.push({
          userId: item.userId,
          limitTime: item.limitTime + " " + item.timePicker,
          salary: Math.floor(item.salary) * 100,
          langDesc: this.queryData.langDesc,
          proportion: item.proportion,
        });
      });
      if (arr[arr.length - 1]) {
        arr[arr.length - 1].proportion = 100 - ((proportion * arr.length) - proportion)
        val[val.length - 1].proportion = 100 - ((proportion * val.length) - proportion)
      }

      this.multipleSelection = arr;
      // console.log(this.multipleSelection)
    },
    timeChange(row, index) {
      this.$set(this.tableData,index, row)
      this.multipleSelection.forEach(item => {
        if (row.userId === item.userId) {
          item.limitTime = row.limitTime + " " + row.timePicker;
        }
      });
    },
    // 时间
    dateChange(row) {
      console.log(this.multipleSelection, "????");
      this.multipleSelection.forEach(item => {
        if (row.userId === item.userId) {
          item.limitTime = row.limitTime + " " + row.timePicker;
        }
      });
    },
    // 单价
    salaryChange(row) {
      if (row.salary < 10) {
        row.salary = 10;
      } else if (row.salary > 10000) {
        row.salary = 10000;
      }
      this.multipleSelection.forEach(item => {
        if (row.userId == item.userId) {
          item.salary = Math.floor(row.salary) * 100;
        }
      });
    },
    //比例
    proportionChange(row, val) {
      if (row.proportion * 1 > 100) {
        row.proportion = 100
        this.$set(this.tableData[val], "proportion", 100)
      }
      this.multipleSelection.forEach(item => {
        if (row.userId == item.userId) {
          item.proportion = row.proportion * 1
        }
      });
    },
  }
};
</script>
<style lang="less" scoped>
.manage {
  .wrap {
    position: relative;
    height: calc(100% - 48px);
    header {
      position: relative;
      height: 36px;
      .sortFiltrate {
        float: right;
        width: 100px;
        height: 36px;
        background: white;
        border: 0px;
        line-height: 0px;
        color: black;
      }
      h3 {
        float: left;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(69, 69, 69, 1);
        line-height: 36px;
      }
      .search {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
      }
      input {
        float: right;
        width: 260px;
        height: 34px;
        line-height: 36px;
        border: 1px solid rgba(184, 196, 206, 1);
        border-radius: 2px;
        padding: 0 10px;
      }
    }
    .btn {
      position: absolute;
      // bottom: 20px;
      left: 50%;
      transform: translate(-50%, 0);
      button {
        margin: 30px;
      }
    }
    // 表格样式开始
    /deep/.el-table {
      .el-table__empty-block {
        // 修改无数据 出现滚动条
        height: 90% !important;
      }
    }
    .el-table {
      margin: 10px auto;
      height: calc(97% - 100px);
      overflow: auto;
      .el-date-editor.el-input {
        // 截止时间
        width: 117px;
      }
      /deep/.el-input__icon {
        line-height: 24px;
      }
      /deep/.el-input__inner {
        width: 140px;
        border: none;
        // border-bottom: 2px solid #999999;
        height: 26px;
        line-height: 24px;
        // text-align: center;
      }
      /deep/.el-date-editor--time-select {
        input {
          width: 100px;
          padding-right: 0px;
        }
      }
      input {
        width: 54px;
      }
      /deep/.row-expand-cover .el-table__expand-icon {
        visibility: hidden;
      }

      /deep/th {
        text-align: center;
      }
      /deep/.el-table__expanded-cell {
        padding: 0;
        padding-left: 20px;
        border-bottom: 0px;
      }
      /deep/.el-table__expanded-cell:hover {
        background: #fff !important;
      }
    }
    /deep/.el-table::before {
      height: 0px;
    }
    /deep/.el-input-number__increase {
      height: 13px !important;
    }
    /deep/.el-table th.is-leaf {
      border-bottom: 0px;
    }

    /deep/ .el-table--enable-row-hover .el-table__body tr {
      // background: rgba(241, 241, 241, 1);
      // margin-bottom: 30px;
      position: relative;
    }
    /deep/.el-table tbody tr:hover {
      box-shadow: 0px 1px 6px 0px rgba(102, 102, 102, 0.5) !important;
      z-index: 1000;
      .operation {
        display: block;
        height: 23px;
      }
    }

    /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
      // table 鼠标滑动效果
      background: rgba(210, 210, 210, 1);
    }

    // /deep/.el-table td,
    //   .el-table th {
    //     // 修改table行高
    //     padding: 11px 0px !important;
    //   //   height: 36px !important;
    //     font-size: 12px;
    //   }
    /deep/.el-table td {
      border-bottom: 0px solid #ffff;
      text-align: center;
      font-size: 12px;
    }
    /deep/.el-table__body-wrapper {
      height: calc(100% - 50px);
      overflow-y: auto;
    }

    //   /deep/.el-table td:nth-child(2) {
    //     // text-align: left;
    //     .cell {
    //       overflow: hidden;
    //       text-overflow: ellipsis;
    //       white-space: nowrap;
    //     }
    //   }
    //   /deep/.el-table .el-table .el-table  td:nth-child(2) {
    //     text-align: center;
    //   }
    /deep/.el-table--enable-row-hover .el-table__body tr tr tr:hover {
      box-shadow: 0px 1px 6px 0px rgba(102, 102, 102, 0.5);
    }
    /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
      // table 鼠标滑动效果
      background: rgba(210, 210, 210, 1);
    }
    #notDate {
      // 暂无数据
      // margin-top: 80px;
      height: 100%;
      img {
        height: 50%;
        width: 50%;
      }
    }
    // 表格样式结束
  }
}
/deep/.el-select .el-input {
  // 修改筛选select
  width: 100%;
}
.filterForm {
  .el-form-item {
    margin-bottom: 10px;
  }
}
</style>
<style lang="less">
.manage {
  main {
    .el-table__body {
      border-collapse: separate !important;
      border-spacing: 0px 2px !important;
    }
  }
}
</style>
